import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import AnalyticChartData from "../../../../../api/AnalyticChartData";
import stateAnalyticApp from "../../../../../state/stateAnalyticApp";
import { GraphComponent } from "../GraphComponent";
import { FilterLegend } from "../FilterLegend";
import { RechartsLineBarChart } from "./RechartsLineBarChart";

export const PrintCountChart = observer(
  ({ refApp, shiftPress, setScaleGraph, setScaleGraphFlag }) => {
    const [modeLegend, setModeLegend] = useState("index");
    const chartSource = AnalyticChartData.DataSet.PRINT.labelCount;
    const isLoaded = stateAnalyticApp.loaded_printed_count;
    const hasData = chartSource.series.length > 0;

    if (isLoaded && !hasData) {
      return null;
    }

    return (
      <GraphComponent
        setScaleGraph={setScaleGraph}
        setScaleGraphFlag={setScaleGraphFlag}
        refApp={refApp}
        shiftPress={shiftPress}
        title="Печать этикеток. Общее количество"
        flag_loaded={isLoaded}
        id="labelCount"
      >
        {/* <FilterLegend
          value={modeLegend}
          onChange={(e) => setModeLegend(e.target.value)}
        /> */}
        <RechartsLineBarChart
          chartData={chartSource.chartData}
          series={chartSource.series}
          type="bar"
          tooltipShared={modeLegend === "index"}
        />
      </GraphComponent>
    );
  },
);
